import React from "react";
import "@/App.css";
import { BrowserRouter, useRoutes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import BeyondSimpleAlignersLanding from "@/pages/BeyondSimpleAlignersLanding";
import MasterclassPage from "@/pages/MasterclassPage";
import ModulePage from "@/pages/ModulePage";
import TrainersPage from "@/pages/TrainersPage";
import TrainerDetailPage from "@/pages/TrainerDetailPage";
import GalleryPage from "@/pages/GalleryPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminPage from "@/pages/AdminPage";
import AdminLogin from "@/pages/AdminLogin";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Google Analytics SPA page_view tracking
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
}

const LANG_PREFIXES = ["en", "it", "de", "fr", "mk", "el"];

const layoutChildren = [
  { index: true, element: <HomePage /> },
  { path: "rreth-nesh", element: <AboutPage /> },
  { path: "evente", element: <EventsPage /> },
  { path: "evente/masterclass", element: <MasterclassPage /> },
  { path: "evente/masterclass/:moduleId", element: <ModulePage /> },
  { path: "evente/:id", element: <EventDetailPage /> },
  { path: "trajnere", element: <TrainersPage /> },
  { path: "trajnere/:id", element: <TrainerDetailPage /> },
  { path: "galeria", element: <GalleryPage /> },
  { path: "blog", element: <BlogPage /> },
  { path: "blog/:id", element: <BlogPostPage /> },
  { path: "kontakt", element: <ContactPage /> },
  { path: "privatesia", element: <PrivacyPage /> },
  { path: "kushtet", element: <TermsPage /> },
  { path: "terms", element: <TermsPage /> },
  { path: "pagesa/sukses", element: <PaymentSuccess /> },
];

const AppRoutes = () => {
  const routes = [
    // Dedicated landing page (NO layout wrapper) — must match before the generic /evente/:id route
    // Support both slug variants AND all localized URL prefixes (en, it, de, fr, mk, el)
    { path: "/evente/beyond-simple-aligners-biomechanics-and-planning-for-severe-malocclusions", element: <BeyondSimpleAlignersLanding /> },
    { path: "/evente/dr-diego-peydro-beyond-simple-aligners-biomechanics-and-planning-for-severe-malocclusions", element: <BeyondSimpleAlignersLanding /> },
    { path: "/:lang/evente/beyond-simple-aligners-biomechanics-and-planning-for-severe-malocclusions", element: <BeyondSimpleAlignersLanding /> },
    { path: "/:lang/evente/dr-diego-peydro-beyond-simple-aligners-biomechanics-and-planning-for-severe-malocclusions", element: <BeyondSimpleAlignersLanding /> },
    { path: "/", element: <Layout />, children: layoutChildren },
    ...LANG_PREFIXES.map((p) => ({
      path: `/${p}`,
      element: <Layout />,
      children: layoutChildren,
    })),
    { path: "/admin/login", element: <AdminLogin /> },
    { path: "/paneli/*", element: <AdminPage /> },
  ];
  return useRoutes(routes);
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
